import { render } from "./OneProductModal.vue?vue&type=template&id=ae36980a"
import script from "./OneProductModal.vue?vue&type=script&lang=js"
export * from "./OneProductModal.vue?vue&type=script&lang=js"

import "./OneProductModal.vue?vue&type=style&index=0&id=ae36980a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__